import { connect } from 'react-redux';
import Portfolio from '../../components/portfolio/Portfolio';
import * as LKactions from '../../actions/lk';
import * as actionsUMK from '../../actions/umk';
import * as actionsCredits from '../../actions/credits';

/* Шапка портфолио берётся из личного дела (GET /users/{id} и фотография);
   учебный план, зачётная книжка и практики нужны только печатной форме. */

const mapStateToProps = ({
  layout,
  lk: { data, selfPhoto, practice },
  portfolio: { info },
  auth: { mid },
  umk: { group, disciplineList },
  credits: { gradebook, semesterGrades },
}) => ({
  user: data,
  selfPhoto,
  layout,
  group,
  portfolio: info,
  userId: mid,
  gradebook,
  semesterGrades,
  practice,
  disciplineList,
});

const mapDispatchToProps = (dispatch) => ({
  didMount: () => {
    dispatch(LKactions.lk());
    dispatch(LKactions.selfPhoto());
    dispatch(LKactions.getPractice());
    dispatch(actionsUMK.umk());
  },
  fetchGradebook: (studentId) => dispatch(actionsCredits.gradebook(studentId, 0)),
  getSemesterGrades: () => dispatch(actionsCredits.getSemesterGrades()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Portfolio);
